<template>
  <div class="dashboard">
    <h3 class="dashboard-title">Placement History</h3>
    <div class="counter-board">
      <div class="placements">
        <div class="box">
          <div class="heading">
            <div class="icon">
              <i class="la la-star-o"></i>
            </div>
            <div class="title">placements</div>
          </div>
          <div class="counter-number">
            <div class="number">29</div>
          </div>
        </div>
      </div>
      <div class="earning">
        <div class="box">
          <div class="heading">
            <div class="icon">
              <i class="las la-wallet"></i>
            </div>
            <div class="title">earning</div>
          </div>
          <div class="counter-number">
            <div class="number">134,789<span class="baht">฿</span></div>
            <div class="update">(updated 20 April 2022)</div>
          </div>
        </div>
      </div>
      <div class="waiting">
        <div class="box">
          <div class="heading">
            <div class="icon">
              <i class="las la-hourglass-half"></i>
            </div>
            <div class="title">waiting for payment</div>
          </div>
          <div class="counter-number">
            <div class="number">34,567<span class="baht">฿</span></div>
            <div class="update">(updated 20 April 2022)</div>
          </div>
        </div>
      </div>
    </div>
    <h3 class="dashboard-title">My Placement Details</h3>
    <div class="placement-list">
      <div class="filter">
        <sui-dropdown
          v-model="current"
          button
          class="icon"
          floating
          labeled
          :options="filter"
          text="FILTER"
        />
      </div>
      <ul class="details-list">
        <li class="details-item">
          <sui-accordion>
            <a is="sui-accordion-title">
              <sui-icon name="dropdown" />
            </a>
            <div class="show-details">
              <ul>
                <li class="candidate">
                  <label>Candidate</label>
                  <div class="text">Jonathan Bowens</div>
                </li>
                <li class="position">
                  <label>Position</label>
                  <div class="text">Full Stack Developer</div>
                </li>
                <li class="commission">
                  <label>Commission Amount</label>
                  <div class="text text-blue">10,159<span>THB</span></div>
                </li>
              </ul>
            </div>
            <sui-accordion-content>
              <div class="hide-details">
                <ul>
                  <li class="offer">
                    <label>Offer Package/Allowances</label>
                    <div class="text">
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Officiis, deserunt?
                    </div>
                  </li>
                  <li class="working-date">
                    <label>Start Working Date</label>
                    <div class="text">20 May 2022</div>
                  </li>
                  <li class="status">
                    <label>Commission Payment Status</label>
                    <div class="text text-blue">Paid</div>
                  </li>
                </ul>
                <!-- <ul class="commission">
                  <li class="amount">
                    <label>Commission Amount</label>
                    <div class="text">
                      10,159<span class="currency">THB</span>
                    </div>
                  </li>
                  <li class="payment-status">
                    <label>Commission Payment Status</label>
                    <div class="text">Pending</div>
                  </li>
                </ul> -->
              </div>
            </sui-accordion-content>
          </sui-accordion>
        </li>
        <li class="details-item">
          <sui-accordion>
            <a is="sui-accordion-title">
              <sui-icon name="dropdown" />
            </a>
            <div class="show-details">
              <ul>
                <li class="candidate">
                  <label>Candidate</label>
                  <div class="text">Jonathan Bowens</div>
                </li>
                <li class="position">
                  <label>Position</label>
                  <div class="text">Full Stack Developer</div>
                </li>
                <li class="commission">
                  <label>Commission Amount</label>
                  <div class="text text-blue">10,159<span>THB</span></div>
                </li>
              </ul>
            </div>
            <sui-accordion-content>
              <div class="hide-details">
                <ul>
                  <li class="offer">
                    <label>Offer Package/Allowances</label>
                    <div class="text">
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Officiis, deserunt?
                    </div>
                  </li>
                  <li class="working-date">
                    <label>Start Working Date</label>
                    <div class="text">20 May 2022</div>
                  </li>
                  <li class="status">
                    <label>Commission Payment Status</label>
                    <div class="text text-blue">Paid</div>
                  </li>
                </ul>
              </div>
            </sui-accordion-content>
          </sui-accordion>
        </li>
        <li class="details-item">
          <sui-accordion>
            <a is="sui-accordion-title">
              <sui-icon name="dropdown" />
            </a>
            <div class="show-details">
              <ul>
                <li class="candidate">
                  <label>Candidate</label>
                  <div class="text">Jonathan Bowens</div>
                </li>
                <li class="position">
                  <label>Position</label>
                  <div class="text">Full Stack Developer</div>
                </li>
                <li class="commission">
                  <label>Commission Amount</label>
                  <div class="text text-blue">10,159<span>THB</span></div>
                </li>
              </ul>
            </div>
            <sui-accordion-content>
              <div class="hide-details">
                <ul>
                  <li class="offer">
                    <label>Offer Package/Allowances</label>
                    <div class="text">
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Officiis, deserunt?
                    </div>
                  </li>
                  <li class="working-date">
                    <label>Start Working Date</label>
                    <div class="text">20 May 2022</div>
                  </li>
                  <li class="status">
                    <label>Commission Payment Status</label>
                    <div class="text text-blue">Paid</div>
                  </li>
                </ul>
              </div>
            </sui-accordion-content>
          </sui-accordion>
        </li>
        <li class="details-item">
          <sui-accordion>
            <a is="sui-accordion-title">
              <sui-icon name="dropdown" />
            </a>
            <div class="show-details">
              <ul>
                <li class="candidate">
                  <label>Candidate</label>
                  <div class="text">Jonathan Bowens</div>
                </li>
                <li class="position">
                  <label>Position</label>
                  <div class="text">Full Stack Developer</div>
                </li>
                <li class="commission">
                  <label>Commission Amount</label>
                  <div class="text text-blue">10,159<span>THB</span></div>
                </li>
              </ul>
            </div>
            <sui-accordion-content>
              <div class="hide-details">
                <ul>
                  <li class="offer">
                    <label>Offer Package/Allowances</label>
                    <div class="text">
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Officiis, deserunt?
                    </div>
                  </li>
                  <li class="working-date">
                    <label>Start Working Date</label>
                    <div class="text">20 May 2022</div>
                  </li>
                  <li class="status">
                    <label>Commission Payment Status</label>
                    <div class="text text-blue">Paid</div>
                  </li>
                </ul>
                <!-- <ul class="commission">
                  <li class="amount">
                    <label>Commission Amount</label>
                    <div class="text">
                      10,159<span class="currency">THB</span>
                    </div>
                  </li>
                  <li class="payment-status">
                    <label>Commission Payment Status</label>
                    <div class="text">Pending</div>
                  </li>
                </ul> -->
              </div>
            </sui-accordion-content>
          </sui-accordion>
        </li>
        <li class="details-item">
          <sui-accordion>
            <a is="sui-accordion-title">
              <sui-icon name="dropdown" />
            </a>
            <div class="show-details">
              <ul>
                <li class="candidate">
                  <label>Candidate</label>
                  <div class="text">Jonathan Bowens</div>
                </li>
                <li class="position">
                  <label>Position</label>
                  <div class="text">Full Stack Developer</div>
                </li>
                <li class="commission">
                  <label>Commission Amount</label>
                  <div class="text text-blue">10,159<span>THB</span></div>
                </li>
              </ul>
            </div>
            <sui-accordion-content>
              <div class="hide-details">
                <ul>
                  <li class="offer">
                    <label>Offer Package/Allowances</label>
                    <div class="text">
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Officiis, deserunt?
                    </div>
                  </li>
                  <li class="working-date">
                    <label>Start Working Date</label>
                    <div class="text">20 May 2022</div>
                  </li>
                  <li class="status">
                    <label>Commission Payment Status</label>
                    <div class="text text-blue">Paid</div>
                  </li>
                </ul>
              </div>
            </sui-accordion-content>
          </sui-accordion>
        </li>
        <li class="details-item">
          <sui-accordion>
            <a is="sui-accordion-title">
              <sui-icon name="dropdown" />
            </a>
            <div class="show-details">
              <ul>
                <li class="candidate">
                  <label>Candidate</label>
                  <div class="text">Jonathan Bowens</div>
                </li>
                <li class="position">
                  <label>Position</label>
                  <div class="text">Full Stack Developer</div>
                </li>
                <li class="commission">
                  <label>Commission Amount</label>
                  <div class="text text-blue">10,159<span>THB</span></div>
                </li>
              </ul>
            </div>
            <sui-accordion-content>
              <div class="hide-details">
                <ul>
                  <li class="offer">
                    <label>Offer Package/Allowances</label>
                    <div class="text">
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Officiis, deserunt?
                    </div>
                  </li>
                  <li class="working-date">
                    <label>Start Working Date</label>
                    <div class="text">20 May 2022</div>
                  </li>
                  <li class="status">
                    <label>Commission Payment Status</label>
                    <div class="text text-blue">Paid</div>
                  </li>
                </ul>
              </div>
            </sui-accordion-content>
          </sui-accordion>
        </li>
        <li class="details-item">
          <sui-accordion>
            <a is="sui-accordion-title">
              <sui-icon name="dropdown" />
            </a>
            <div class="show-details">
              <ul>
                <li class="candidate">
                  <label>Candidate</label>
                  <div class="text">Jonathan Bowens</div>
                </li>
                <li class="position">
                  <label>Position</label>
                  <div class="text">Full Stack Developer</div>
                </li>
                <li class="commission">
                  <label>Commission Amount</label>
                  <div class="text text-blue">10,159<span>THB</span></div>
                </li>
              </ul>
            </div>
            <sui-accordion-content>
              <div class="hide-details">
                <ul>
                  <li class="offer">
                    <label>Offer Package/Allowances</label>
                    <div class="text">
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Officiis, deserunt?
                    </div>
                  </li>
                  <li class="working-date">
                    <label>Start Working Date</label>
                    <div class="text">20 May 2022</div>
                  </li>
                  <li class="status">
                    <label>Commission Payment Status</label>
                    <div class="text text-blue">Paid</div>
                  </li>
                </ul>
              </div>
            </sui-accordion-content>
          </sui-accordion>
        </li>
      </ul>
    </div>
    <div class="paging">
      <Pagination />
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import Pagination from "../../components/ui/Pagination.vue";
export default {
  name: "DashboardPlacementHistory",
  components: {
    Pagination,
  },
  data() {
    return {
      current: null,
      filter: [
        { key: "All Payment", text: "All Payment", value: "DatAll Payment" },
        { key: "Paid Payment", text: "Paid Payment", value: "Paid Payment" },
        {
          key: "Waiting Payment",
          text: "Waiting Payment",
          value: "Waiting Payment",
        },
        {
          key: "Sort by Newest Placement",
          text: "Sort by Newest Placement",
          value: "Sort by Newest Placement",
        },
        {
          key: "Sort by Oldest Placement",
          text: "Sort by Oldest Placement",
          value: "Sort by Oldest Placement",
        },
      ],
    };
  },
  // mounted() {
  //   $(".details-item a").click(function (e) {
  //     e.preventDefault();
  //     $(".details-item a i").toggleClass(
  //       "las la-plus-circle las la-minus-circle"
  //     );
  //   });
  // },
};
</script>
<style lang="scss">
@import "~@/assets/stylesheets/application";
.dashboard {
  .counter-board {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 1rem 0;
    padding-bottom: 2rem;

    .box {
      width: 300px;
      align-items: center;
      border-radius: 25px;
      color: $white;
      display: flex;
      flex-direction: column;
      height: 200px;
      justify-content: space-evenly;
      padding: 15px 15px;
      margin-right: 15px;
      margin-bottom: 1rem;
      .heading {
        display: flex;
        flex-direction: column;
        align-items: center;
        .icon {
          i {
            font-size: 50px;
            opacity: 0.8;
          }
        }

        .title {
          font-size: 14px;
          font-weight: 500;
          text-transform: uppercase;
        }
      }
      .counter-number {
        display: flex;
        flex-direction: column;
        align-items: center;
        .number {
          font-size: 60px;
          font-weight: 700;
          line-height: 50px;
        }
      }
    }

    .placements {
      .box {
        background: #3742fa;

        /* fallback */
        background-image: linear-gradient(to top, #2731fa, #3742fa);
      }
    }
    .earning {
      .box {
        background: #4aa4ff;

        /* fallback */
        background-image: linear-gradient(to top, #3399ff, #4aa4ff);
        .counter-number {
          .number {
            display: flex;
            align-items: center;
            font-size: 40px;
            padding: 0;
            .baht {
              font-size: 25px;
              margin-left: 10px;
            }
          }
          .update {
            font-size: 12px;
            opacity: 0.8;
          }
        }
      }
    }
    .waiting {
      .box {
        background: #9535f2;

        /* fallback */
        background-image: linear-gradient(to top, #9535f2, #a55eea);
        .counter-number {
          .number {
            display: flex;
            align-items: center;
            font-size: 40px;
            padding: 0;
            .baht {
              font-size: 25px;
              margin-left: 10px;
            }
          }
          .update {
            font-size: 12px;
            opacity: 0.8;
          }
        }
      }
    }
  }
  .placement-list {
    padding: 1rem 0;
  }
  .filter {
    .ui.floating.dropdown > .menu {
      margin-top: 12px !important;
      overflow: scroll;
      max-height: 15rem;
      background: white !important;
    }
    .ui.icon.button {
      background: none;
      border-radius: 100rem;
      font-family: "Poppins", sans-serif;
      border: 1px solid $black;
      padding: 0.75rem 1rem !important;
      z-index: 20;
      &:hover,
      &:focus {
        /* stylelint-disable-next-linedeclaration-no-important */
        box-shadow: none !important;
        filter: contrast(150%);
        text-decoration: none;
        background: none;
      }
    }
    .ui.labeled.icon.button {
      padding-left: 45px !important;
      padding: 1rem;
    }
    .ui.dropdown > .dropdown.icon {
      background: none !important;
    }
    .ui.dropdown > .dropdown.icon:before {
      color: $black;
      content: "\f0b0";
      font-family: "Line Awesome Free";
      font-weight: 900;
      margin-left: 10px;
      font-size: 20px !important;
    }
    .ui.dropdown > .text {
      font-size: 14px;
      font-weight: 500;
      color: $black;
    }
  }
  .details-list {
    padding: 1rem 0;
    .details-item {
      position: relative;
      width: 100%;
      padding: 15px 15px;
      border-radius: 15px;
      border: 1px solid $blue-primary;
      margin-bottom: 1rem;
      a {
        position: absolute;
        top: 5px;
        right: 15px;
        .dropdown.icon:before {
          content: "\f055";
          font-family: "Line Awesome Free";
          font-weight: 900;
          font-size: 28px;
          color: $blue-primary;
        }
        &.active.title .dropdown.icon {
          transform: unset;
        }
        &.active.title .dropdown.icon:before {
          content: "\f056" !important;
        }
      }
      .show-details {
        li {
          margin-bottom: 0;
        }
      }
      .hide-details {
        padding-top: 10px;
      }
      ul {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;
        li {
          width: 32%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          margin-bottom: 10px;
          label {
            color: $black;
            font-size: 14px;
            font-weight: 700;
            margin-bottom: 2px;
          }
          .text {
            color: $black;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
              Helvetica, Arial, sans-serif, "Apple Color Emoji",
              "Segoe UI Emoji", "Segoe UI Symbol";
            font-size: 14px;
            line-height: 1.5rem;
            padding-right: 15px;
          }
          .text-blue {
            color: $blue-primary;
            font-weight: 700;
            span {
              margin-left: 10px;
            }
          }
        }
      }
      // ul.commission {
      //   li {
      //     width: 50%;
      //     display: flex;
      //     flex-direction: row;
      //     align-items: center;
      //     margin-bottom: 10px;
      //     label {
      //       margin-bottom: 0;
      //       margin-right: 10px;
      //     }
      //     .text {
      //       color: $blue-primary;
      //       font-weight: 700;
      //       line-height: 0;
      //       .currency {
      //         margin-left: 10px;
      //       }
      //     }
      //   }
      // }
    }
  }
  //fix sui-accordion
  .ui.accordion:not(.styled) .title ~ .content:not(.ui):last-child {
    padding: 0;
  }
}
@media only screen and (max-width: 991px) {
  .dashboard {
    .counter-board {
      display: block;
      padding: 0;
      padding-bottom: 1rem;

      .box {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        height: 90px;
        border-radius: 15px;
        margin: 0;
        margin-bottom: 1rem;
        width: auto;
        .heading {
          align-items: flex-start;
          .icon {
            i {
              font-size: 30px;
            }
          }

          .title {
            font-size: 12px;
          }
        }
        .counter-number {
          display: flex;
          flex-direction: column;
          align-items: center;
          .number {
            font-size: 35px;
            line-height: 35px;
          }
        }
      }

      .placements {
        .box {
          background: #3742fa;

          /* fallback */
          background-image: linear-gradient(to top, #2731fa, #3742fa);
        }
      }
      .earning,
      .waiting {
        .box {
          .counter-number {
            .number {
              font-size: 35px;
              line-height: 35px;
              .baht {
                font-size: 20px;
                margin-left: 10px;
              }
            }
            .update {
              font-size: 10px;
              opacity: 0.8;
            }
          }
        }
      }
    }
    .placement-list {
      padding: 0;
    }
    .details-list {
      padding: 1rem 0;
      .details-item {
        a {
          top: 5px;
          right: 15px;
        }
        .show-details {
          li {
            margin-bottom: 10px;
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
        .hide-details {
          padding-top: 10px;
        }
        ul {
          li {
            width: 100%;
            margin-bottom: 10px;
            label {
              font-size: 14px;
            }
            .text {
              padding-right: 0;
            }
          }
        }
      }
    }
  }
}
</style>
